import { useRef, useState, useEffect } from 'react';
import { useOverlaySidebar } from '../context/OverlaySidebarContext';
import '../styles/Layout.css'
import Button from './Button';
import ConfigStepper from './ConfigStepper';
import { Toast } from 'primereact/toast';
import { CodeLineageConfigAPI } from '../api/codeLineageConfig.api';
import PageLoader from './PageLoader';


const RightOverlaySidebar = () => {

  const { isOpen, closeOverlay } = useOverlaySidebar();
  const [formData, setFormData] = useState({
    repoURL: "",
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [repoID, setRepoID] = useState(null);
  const [refreshflag, setrefresh] = useState(null)
  const [isLocked, setIsLocked] = useState(false);
  const [isproceed, setIsProceed] = useState();
  const [opflag, setOpFlag] = useState();
  const [isconnect, setIsconnect] = useState(true);
  // const [completeFlag , setcompleteFlag ] = useState(1)
  const [iserror, setIserror] = useState(false)
  const [passwordLabel, setPasswordLabel] = useState('Password')

  const Poll_Interval = 15000; // 15 seconds
  const toast = useRef(null);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const maxDurationRef = useRef(null);

  const user_unique_id = useRef(crypto.randomUUID());

  const [steps, setSteps] = useState([
    {
      id: 1,
      title: 'Download Files',
      description: 'Download all File(s) from repo.',
      status: 'Pending',
    },
    {
      id: 2,
      title: 'Identify The Scripting Language',
      description: 'Scripting for Code lineage',
      status: 'Pending',
    },
    {
      id: 3,
      title: 'Configure',
      description: 'JSON Generation for Code lineage & Graph DB Injection for Code lineage',
      status: 'Pending',
    },
    {
      id: 4,
      title: 'Clean Up',
      description: 'Cleanup the repo folder after all configuration is completed',
      status: 'Pending',
    }
  ])
  const handleReset = () => {
    try {
      setIsLocked(false)
      setIsconnect(true)
      setIsProceed(3)
      setrefresh(4)
      setIserror(false)
      setFormData({ repoURL: "", username: "", password: "" });
      setSteps([
        {
          id: 1,
          title: 'Download Files',
          description: 'Download all File(s) from repo.',
          status: 'Pending',
        },
        {
          id: 2,
          title: 'Identify The Scripting Language',
          description: 'Scripting for Code lineage',
          status: 'Pending',
        },
        {
          id: 3,
          title: 'Metadata Ingestion',
          description: 'JSON Generation for Code lineage & Graph DB Injection for Code lineage',
          status: 'Pending',
        },
        {
          id: 4,
          title: 'Wrap Up',
          description: 'Cleanup the repo folder after all configuration is completed',
          status: 'Pending',
        }
      ]
      )
    } catch (error) {

    }
  }

  const validate = () => {
    let newErrors = {};
    if (!formData.repoURL) {
      newErrors.repoURL = "Repository URL is required";
    } else {
      try {
        new URL(formData.repoURL);
      } catch {
        newErrors.repoURL = "Invalid URL format";
      }
    }
    if (!formData.username) newErrors.username = "Username is required";
    // if (!formData.password) newErrors.password = "Password/Token is required";
    if (!formData.password) {
      const cleaned = removeUsernameFromUrl(formData?.repoURL);
      const url = cleaned?.toLowerCase() || "";

      if (url.startsWith("https://github.com/")) {
        newErrors.password = "Password is required";
      } else if (
        url.startsWith("https://dev.azure.com/") ||
        url.startsWith("https://bitbucket.org/")
      ) {
        newErrors.password = "Personal Access Token is required";
      } else {
        newErrors.password = "Password is required";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };
  const showSuccess = (message) => {
    let severity = (message.status === "failed") ? "error" : message.status
    toast.current.show({ severity: severity, summary: severity, detail: message.message, life: 3000 });
  }

  const showFailed = (message) => {
    toast.current.show({ severity: 'error', summary: 'Failed', detail: message, life: 3000 });
  }

  useEffect(() => {
    if (formData?.repoURL) {
      const cleaned = removeUsernameFromUrl(formData?.repoURL);
      const url = cleaned?.toLowerCase();

      if (url.startsWith("https://github.com/")) {
        setPasswordLabel("Password");
      } else if (
        url.startsWith("https://dev.azure.com/") ||
        url.startsWith("https://bitbucket.org/")
      ) {
        setPasswordLabel("Personal Access Token");
      } else {
        setPasswordLabel("Password");
      }
    }
  }, [formData?.repoURL]);

  const connectClick = async () => {
    try {
      if (!validate()) return;
      // const encodedPassword = btoa(formData.password); // Base64 encoding
      const cleaned = removeUsernameFromUrl(formData.repoURL);
      // console.log('url',formData.repoURL,cleaned);
      const payload = {
        gitlink: cleaned,
        username: formData.username,
        password: formData.password,
      };
      setIsLocked(true)
      setIsconnect(false);
      setLoader(true)
      const response = await CodeLineageConfigAPI.postconnectRepo(payload)
      const data = await response.data; //  parse JSON body
      if (response.status === 200) {
        setOpFlag(data.op_flag);
        showSuccess(data);
        if (data.op_flag === 2) {
          setrefresh(data.op_flag)
        }
        else {
          setIsProceed(data.op_flag)
        }
      }
      else {
        setIsconnect(true)
        showSuccess(data)
        setIsLocked(false)

      }
    } catch (err) {
      setIsLocked(false)
      setIsconnect(true);
      showFailed(err?.response?.data?.message)

    }
    finally {
      setLoader(false)
    }
  }

  const proceeddownloadfile = async (id) => {
    try {
      const currentStep = steps.find(step => step.status === "Pending" || step.status === "Error");
      if (!currentStep) return; // all steps done
      if (id === 1) {
        if (!validate()) return;
        // Encode password before sending
        // const encodedPassword = btoa(formData.password); // Base64 encoding
        const cleaned = removeUsernameFromUrl(formData.repoURL);
        const payload = {
          gitlink: cleaned,
          username: formData.username,
          password: formData.password,
          op_flag: opflag
        };
        console.log("formData", payload);
        // Mark it as In Progress
        setSteps(prevSteps =>
          prevSteps.map(step =>
            step.id === currentStep.id ? { ...step, status: "In Progress" } : step
          )
        );
        try {
          const response = await CodeLineageConfigAPI.postdownLoadFiles(payload)
          const data = await response.data;
          console.log("2nd api :", response, data)
          if (response.status === 200) {
            showSuccess(data)
            setRepoID(data.data.RepoId);
            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Completed" } : step
              )
            );
          } else {
            // showSuccess(data)
            showFailed(data.message)
            setIsLocked(false)
            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Pending" } : step
              )
            );
          }
        } catch (err) {
          setIsLocked(false)
          showFailed(err.response.data.message)
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Pending" } : step
            )
          );
        }
      }

    } catch (error) {

    }
  }





  const handleSubmit = async () => {
    try {
      const currentStep = steps.find(step => step.status === "Pending" || step.status === "Error");
      if (!currentStep) return; // all steps done


      if (currentStep.id === 2) {
        // Mark step as In Progress
        setSteps(prevSteps =>
          prevSteps.map(step =>
            step.id === currentStep.id ? { ...step, status: "In Progress" } : step
          )
        );
        const Payload = {
          "user_id": user_unique_id.current,
          "api_endpoint": "analyze",
          "in_parameter": {
            "repo_id": repoID
          }
        }

        try {
          const response = await CodeLineageConfigAPI.postApi_BatchProcessing(Payload)
          const data = await response.data;
          console.log("2nd api :", response, data)
          if (response.status === 200) {
            // showSuccess(data)
            // setSteps(prevSteps =>
            //   prevSteps.map(step =>
            //     step.id === currentStep.id ? { ...step, status: "Completed" } : step
            //   )
            // );
            // maxDurationRef.current = Number(data.data.delay) * 60 * 1000;
            startPolling(data.data.user_id, data.data.req_id, 2);
          }
          else {
            showSuccess(data)
            setIserror(true);
            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Pending" } : step
              )

            );
            console.log("step id", steps, currentStep.id)

          }
        } catch (err) {
          console.log("err", err)
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Pending" } : step
            )
          );
          showFailed(err?.message)
          setIserror(true);
          // showSuccess(err)

        }
      }

      else if (currentStep.id === 3) {
        // Mark step as In Progress
        setSteps(prevSteps =>
          prevSteps.map(step =>
            step.id === currentStep.id ? { ...step, status: "In Progress" } : step
          )
        );
        const Payload = {
          "user_id": user_unique_id.current,
          "api_endpoint": "metadata-ingestion",
          "in_parameter": {
            "repo_id": repoID
          }
        }
        try {
          const response = await CodeLineageConfigAPI.postApi_BatchProcessing(Payload)
          const data = await response.data; //  parse JSON safely
          if (response.status === 200) {
            // maxDurationRef.current = Number(data.data.delay) * 60 * 1000;
            startPolling(data.data.user_id, data.data.req_id, 3);
          }
          else {
            showFailed(data.data);
            setIserror(true);
            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Pending" } : step
              )
            );
          }
        } catch (err) {
          setIserror(true);
          showFailed(err?.response?.data?.message)
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Pending" } : step
            )
          );
        }
      }
      else if (currentStep.id === 4) {
        setSteps(prevSteps =>
          prevSteps.map(step =>
            step.id === currentStep.id ? { ...step, status: "In Progress" } : step
          )
        );

        const reopid = {
          "repo_id": repoID
        }

        try {
          const response = await CodeLineageConfigAPI.repocleanup(reopid)

          const data = await response.data; //  parse JSON safely

          if (response.status === 200) {
            showSuccess(data)


            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Completed" } : step
              )
            );

          }
          else {
            showSuccess(data)
            setIserror(true);
            setSteps(prevSteps =>
              prevSteps.map(step =>
                step.id === currentStep.id ? { ...step, status: "Pending" } : step
              )
            );
          }
        } catch (err) {
          setIserror(true);
          showFailed(err.response.data.message)
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Pending" } : step
            )
          );
        }
      }

    } catch (error) {
      console.error(error);
    }
  };

  // const startPolling = (userId, requestId, stepid) => {
  //   startTimeRef.current = Date.now();
  //   console.log("start time", startTimeRef.current)
  //   console.log("check time ", Date.now() - startTimeRef.current, maxDurationRef.current)
  //   const currentStep = steps.find(step => step.id === stepid);
  //   intervalRef.current = setInterval(async () => {
  //     //stop if max duration cross
  //     console.log("start time", startTimeRef.current)
  //     console.log("check time ", Date.now() - startTimeRef.current, maxDurationRef.current)
  //     if (Date.now() - startTimeRef.current > maxDurationRef.current) {
  //       clearInterval(intervalRef.current);
  //       showFailed("Process Failed: Time Limit Exceeded")
  //       console.log("check time ", Date.now() - startTimeRef.current > maxDurationRef.current)
  //       setIserror(true);
  //       setSteps(prevSteps =>
  //         prevSteps.map(step =>
  //           step.id === currentStep.id ? { ...step, status: "Pending" } : step
  //         )
  //       );
  //       return;
  //     }

  //     try {
  //       const res = await callGetApi(userId, requestId);
  //       console.log("get api res", res);
  //       if (res.data.process_status === 2) {
  //         clearInterval(intervalRef.current);
  //         showSuccess(res.data.output);
  //         console.log("currentstep", currentStep);
  //         setSteps(prevSteps =>
  //           prevSteps.map(step =>
  //             step.id === currentStep.id ? { ...step, status: "Completed" } : step
  //           )
  //         );

  //       }
  //       if (res.data.process_status === 3) {
  //         clearInterval(intervalRef.current);
  //         showFailed("Process Failed")
  //         setIserror(true);
  //         setSteps(prevSteps =>
  //           prevSteps.map(step =>
  //             step.id === currentStep.id ? { ...step, status: "Pending" } : step
  //           )
  //         );
  //       }
  //     } catch (err) {
  //       clearInterval(intervalRef.current);
  //       showFailed("Error While Checking Status");
  //       setIserror(true);
  //       setSteps(prevSteps =>
  //         prevSteps.map(step =>
  //           step.id === currentStep.id ? { ...step, status: "Pending" } : step
  //         )
  //       );
  //     }
  //   }, Poll_Interval)
  // }

  const startPolling = (userId, requestId, stepid) => {
    const currentStep = steps.find(step => step.id === stepid);

    // Clear any existing interval before starting a new one
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(async () => {
      try {
        const res = await callGetApi(userId, requestId);
        console.log("get api res", res);

        if (res.data.process_status === 2) {
          clearInterval(intervalRef.current);
          showSuccess(res.data.output);
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Completed" } : step
            )
          );
        }

        if (res.data.process_status === 3) {
          clearInterval(intervalRef.current);
          showFailed("Process Failed");
          setIserror(true);
          setSteps(prevSteps =>
            prevSteps.map(step =>
              step.id === currentStep.id ? { ...step, status: "Pending" } : step
            )
          );
        }
      } catch (err) {
        clearInterval(intervalRef.current);
        showFailed("Error While Checking Status");
        setIserror(true);
        setSteps(prevSteps =>
          prevSteps.map(step =>
            step.id === currentStep.id ? { ...step, status: "Pending" } : step
          )
        );
      }
    }, 10000); // Poll every 10 seconds
  };

  const callGetApi = async (userId, requestId) => {
    const currentStep = steps.find(step => step.id === 3);
    const payload = {
      "req_id": requestId,
      "user_id": userId
    };

    const response = await CodeLineageConfigAPI.postApi_BatchProcessing_status(payload)
    const data = await response.data;
    if (response.status === 200) {

    }
    else {
      setSteps(prevSteps =>
        prevSteps.map(step =>
          step.id === currentStep.id ? { ...step, status: "Pending" } : step
        )
      );
      showFailed("Error : Unable to connect Server. Please Retry")
      setIserror(true);
    }

    return data;

  }


  function removeUsernameFromUrl(repoUrl) {
    try {
      const url = new URL(repoUrl);
      // Clear username and password if present
      url.username = "";
      url.password = "";
      return url.toString();
    } catch (err) {
      console.error("Invalid URL:", err);
      return repoUrl; // fallback
    }
  }

  const isAnyInProgress = steps.some(step => step.status === "In Progress");
  const isAllStepCompleted = steps.every(step => step.status === "Completed");
  const isStepError = steps.some(step => step.status === "Error");



  return (
    <>
      {isOpen && <div className="overlay-backdrop" onClick={closeOverlay} />}
      <div className={`overlay-sidebar ${isOpen ? "open" : ""}`}>
        <div className="overlay-sidebar-content">
          <div className='w-100 d-flex justify-content-end'>
            <button className="close-btn" onClick={closeOverlay}></button>
          </div>
          <div className='overlayBody'>
            <div>
              <div>
                <h4 className='overlayHeadText'>Configure</h4>
              </div>
              {/* <div className="configInputSection">
                <label className='configInputLabel'>Configure Type</label>
                <SearchableDropdown
                  // options={config}
                  label="repo_name"
                  id="repo_id"
                  // selectedVal={selectedRepo}
                  // handleChange={(value) => {
                  //   localStorage.removeItem('chatDataAdvancedCL')
                  //   setMessages([])
                  //   setSelectedGraphUrl(null)
                  //   setSelectedId(null)
                  //   onRepoSelect(value)
                  // }}
                  placeholder='Please select'
                  showClear={false}
                />
              </div> */}
              <div className="configInputSection">
                <label className='configInputLabel'>Repository URL</label>
                <input
                  type="text"
                  id="repoURL"
                  name="repoURL"
                  placeholder='Enter URL'
                  className='configInput'
                  value={formData.repoURL}
                  onChange={handleChange}
                  disabled={isLocked}
                  autoComplete='off'
                />
                {errors.repoURL && <span className="errorText">{errors.repoURL}</span>}
              </div>

              <div className="configInputSection">
                <label className='configInputLabel'>Username</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder='Enter Username'
                  className='configInput'
                  value={formData.username}
                  onChange={handleChange}
                  disabled={isLocked}
                  autoComplete='off'
                />
                {errors.username && <span className="errorText">{errors.username}</span>}
              </div>

              <div className="configInputSection">
                <label className='configInputLabel'>{passwordLabel}</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder='Enter'
                  className='configInput'
                  value={formData.password}
                  onChange={handleChange}
                  disabled={isLocked}
                  autoComplete='off'
                />
                {errors.password && <span className="errorText">{errors.password}</span>}
              </div>

              <div className='buttonspace'>
                {(isconnect) &&
                  <Button variant="primary" onClick={connectClick} >CONNECT</Button>
                }
                {(refreshflag === 2) && ["Pending"].includes(steps.find(s => s.id === 1).status) &&
                  <Button variant="primary" onClick={() => proceeddownloadfile(1)}>Refresh Repo.</Button>
                }
                {(refreshflag === 2) && ["Pending"].includes(steps.find(s => s.id === 1).status) && (
                  <Button variant="primary" onClick={handleReset}>Reset</Button>
                )
                }
                {(isproceed === 1) && ["Pending"].includes(steps.find(s => s.id === 1).status) &&
                  <Button variant="primary" onClick={() => proceeddownloadfile(1)}>Proceed</Button>
                }
                {(isAllStepCompleted || iserror === true) &&
                  <Button variant="primary" onClick={handleReset}>Reset</Button>
                }
              </div>
            </div>
            <div >
              <ConfigStepper
                steps={steps}
                onStepClick={handleSubmit}
                isAnyInProgress={isAnyInProgress}
              />
            </div>
          </div>
        </div>
      </div>
      <Toast ref={toast} position="top-center" />
      <PageLoader show={loader} />
    </>
  );
};

export default RightOverlaySidebar;
